import $ from 'jquery';
import debug from 'debug';
import plugin from '@core/plugins/lib';

const ELEMENT_SELECTOR = '[data-tabs-controller]';
const PLUGIN_NAME = 'tabsController';

const log = debug('tabs-controller');

class TabsController {
	constructor(element, options) {
		log('element', element);
		log('options', options);

		this.options = options;
		this.element = element;
		this.$element = $(element);

		this.tabs = this.selectors.selectTarget(
			this.options.tabsSelector,
			this.$element
		);

		this.watch();

		log('ready', this, this.$target);
	}

	watch() {
		log('watching');
		this.$element.on('closeothers', this.closeOtherTabs.bind(this));
	}

	closeOtherTabs(event){
		const openingTab = event.target;

		const tabsToClose = this.tabs.filter(function(index, tab) {
			return tab !== openingTab;
		});

		tabsToClose.each((index, tab) => {
			tab.dataset.collapsibleOpen = false;
        });
        
        window.dispatchEvent(new Event('resize'));

	}
}

TabsController.DEFAULTS = {};

plugin(PLUGIN_NAME, TabsController);

export function exec() {
    $(document).ready(() => {
		$(ELEMENT_SELECTOR)[PLUGIN_NAME]();
	});

}


// WEBPACK FOOTER //
// ./client/src/core/components/tabs/index.js